import { LIMIT, mailApi } from '@/store/api/mail/mail.api';
import type { TypeAppDispatch } from '@/store/store';
import type { TypeMail, TypeMailTarget } from '@/types/mail/types.mail';

export const writeMail = (dispatch: TypeAppDispatch, mail: TypeMail) => {
    const target: TypeMailTarget | null = mail.quoteId ? { quoteId: mail.quoteId } : mail.invoiceId ? { invoiceId: mail.invoiceId } : null;
    if (!target) return;
    dispatch(mailApi.util.updateQueryData('listMails', target, (draft) => {
        const index = draft.findIndex((entry) => entry.id === mail.id);
        if (index >= 0) draft[index] = mail;
        else draft.unshift(mail);
        draft.splice(LIMIT);
    }));
};
